import { simpleSet } from '@r/reducers/utils';

export const drawerLabourUnit = simpleSet(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_DRAWER_LABOUR_UNIT',
  0
);
